import ZeroStore from 'redux-zero/interfaces/Store';
import { BookingState } from './state';

export interface Store<T> extends ZeroStore<T> {
  shutdown?: () => void;
}

export interface StoreContext<T> {
  store: Store<T>;
}

type fn = () => any;

/** Type safe version of Actions with injected State */
export type StoreActions<State, ActionModel> = {
  [action in keyof ActionModel]: (
    state: State,
    ...x: Parameters<fn & ActionModel[action]>
  ) => ReturnType<fn & ActionModel[action]>;
};

export type ActionsFactory<State, ActionModel> = {
  (store?: Store<State>): StoreActions<State, ActionModel>;
};

// eslint-disable-next-line @typescript-eslint/ban-types
export type Middleware<T> = (store: Store<T>) => (next: Function) => (action: Function) => any;

export enum LifecycleEvent {
  INIT = '$storeInit',
  INTERVAL = '$storeInterval',
  SHUTDOWN = '$storeShutdown',
}

export interface SideEffectAction<T> {
  (state: T): T | Promise<T>;
  id?: string;
}

export interface LifecycleEventEffect<T> {
  type: LifecycleEvent;
  when?: (prev: T, next: T) => boolean;
}

/**
 * Way to run side effects when relevant state changes are detected.
 */
export interface SideEffect<T> {
  /** Side-effect name */
  name: string;
  /** Method to run all sub side-effects */
  runSideEffects: (state: Readonly<BookingState>) => void;
  /** When this effect should be run? */
  when: (prev: T, next: T) => boolean;
  /** Run effect also for these lifecycle events. */
  runOn?: LifecycleEventEffect<T>[];
}

export type SideEffectGenerator<T> = (store: Store<T>) => SideEffect<T>;
